import { Icons } from '@densityco/ui';

import styles from './styles.module.scss';

export const DeprecationBanner: React.FC = () => {
  return (
    <div className={styles.DeprecationBanner}>
      <div className={styles.BannerIcon}>
        <Icons.DensityMark color="#ffffff" width={14} height={14} />
      </div>
      <div className={styles.BannerText}>
        Your organization now has access to Atlas.{' '}
        <a href="https://atlas.density.io">Go to Atlas</a>
        {'→'}
      </div>
    </div>
  );
};
